"use client";
import React from "react";
import { motion } from "framer-motion";
import HeaderInner from "../../utility/HeaderInner";
import { directorsData } from "../../utility/Navigation";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const Management = () => {
  return (
    <div className="mt-70">
      <HeaderInner
        title={"Board of Directors"}
        shortDescription={"Management Team"}
      />

      {/* Directors Section */}
      <section className="py-5 bg-light">
        <div className="container">
          {/* Tribute Section */}
          <motion.div
            className="bg-white p-4 rounded shadow-sm mb-2"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <p className="text-muted mb-3">
              In the remembrance of Late M.P. Chary, Founder, we tribute him for
              his expertise and experience in establishing companies dealing
              with a variety of businesses like Biotechnology, High-end
              diagnostics, Software Development, and Technology-enabled Learning
              Solutions.
            </p>
            <div style={{ width: "36px", height: "26px" }}>
              <svg
                width={36}
                height={26}
                viewBox="0 0 36 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 15.3698H7.71428L2.57139 25.5546H10.2857L15.4286 15.3698V0.0924683H0V15.3698Z"
                  fill="#0d6efd"
                />
                <path
                  d="M20.5703 0.0924683V15.3698H28.2846L23.1417 25.5546H30.856L35.9989 15.3698V0.0924683H20.5703Z"
                  fill="#0d6efd"
                />
              </svg>
            </div>
          </motion.div>

          {/* Director Profiles */}
          {directorsData.map((director, idx) => (
            <motion.div
              key={idx}
              className="d-flex flex-column flex-md-row gap-3 bg-white p-4 rounded shadow mb-3"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <img
                src={director.img}
                alt={director.name}
                className="rounded-circle border"
                style={{
                  width: "128px",
                  height: "128px",
                  objectFit: "contain",
                  flexShrink: 0, // prevents shrinking inside flex
                }}
              />
              <div className="flex-grow-1">
                <h5 className="fs-5 fw-semibold text-dark mb-1">
                  {director.name}
                </h5>
                <span className="text-primary d-block mb-2">
                  {director.role}
                </span>
                <p className="text-muted">{director.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Management;
